import { cn } from '@/lib/utils';

const GRADE_CLASSES: Record<string, string> = {
  A: 'bg-teal text-white',
  B: 'bg-teal-light text-teal-dark',
  C: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300',
  D: 'bg-destructive/10 text-destructive',
  F: 'bg-destructive/10 text-destructive',
};

const DEFAULT_CLASS = 'bg-destructive/10 text-destructive';

const SIZE_CLASSES = {
  sm: 'text-[10px] px-1.5 py-0.5',
  md: 'text-xs px-2 py-0.5',
} as const;

interface GradeBadgeProps {
  grade: string | null;
  size?: 'sm' | 'md';
  showEmpty?: boolean;
  className?: string;
}

export function GradeBadge({ grade, size = 'sm', showEmpty = false, className }: GradeBadgeProps) {
  if (grade === null || grade === undefined) {
    if (!showEmpty) return null;
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-full font-medium leading-none',
          DEFAULT_CLASS,
          SIZE_CLASSES[size],
          className,
        )}
      >
        &mdash;
      </span>
    );
  }

  const normalized = grade.toUpperCase();
  const colorClass = GRADE_CLASSES[normalized] ?? DEFAULT_CLASS;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium leading-none',
        colorClass,
        SIZE_CLASSES[size],
        className,
      )}
    >
      {normalized}
    </span>
  );
}
